import {
  Table,
  message,
  Button,
  Row,
  Col,
  Image,
  Tag,
  Tooltip
} from "antd";

import {
  EditOutlined
} from "@ant-design/icons";

import {
  Link
} from "react-router-dom";

import {
  useEffect,
  useState
} from "react";

import axiosInstance from "../../../utils/axios";

export default function IndexManage() {
  const [index, setIndex] = useState([]);

  const fetchIndexPage = async () => {
    try {
      const res = await axiosInstance.get(
        "/index-page/getAllIndexPage"
      );

      setIndex(
        res?.data?.data || []
      );
    } catch (_) {
      message.error(
        "Không tải được danh sách banner"
      );
    }
  };

  useEffect(() => {
    fetchIndexPage();
  }, []);

  const columns = [
    {
      title: "ID",
      key: "index_page_id",
      dataIndex: "index_page_id",
      width: 80,
      sorter: (a, b) =>
        Number(a.index_page_id) -
        Number(b.index_page_id)
    },

    {
      title: "Ảnh",
      key: "index_page_image",
      dataIndex: "index_page_image",
      width: 190,
      render: (_, record) => (
        <div
          style={{
            width: 160,
            height: 90,
            borderRadius: 10,
            overflow: "hidden",
            background: "#f8fafc",
            border: "1px solid #e5e7eb"
          }}
        >
          {record?.index_page_image ? (
            <Image
              src={record.index_page_image}
              preview
              width="100%"
              height="100%"
              style={{
                objectFit: "cover"
              }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#94a3b8",
                fontSize: 12
              }}
            >
              Chưa có ảnh
            </div>
          )}
        </div>
      )
    },

    {
      title: "Vị trí",
      key: "index_page_position",
      dataIndex: "index_page_position",
      width: 180,
      render: (_, record) => {
        const isPromo =
          record?.index_page_position === "promo";

        return isPromo ? (
          <Tag color="volcano">
            Banner ưu đãi - Mục 5
          </Tag>
        ) : (
          <Tag color="blue">
            Banner chính đầu trang
          </Tag>
        );
      }
    },

    {
      title: "Link",
      key: "index_page_link",
      dataIndex: "index_page_link",
      width: 320,
      render: (_, record) => {
        const link =
          record?.index_page_link || "";

        if (!link) {
          return (
            <span
              style={{
                color: "#94a3b8"
              }}
            >
              Chưa có link
            </span>
          );
        }

        return (
          <Tooltip title={link}>
            <div
              style={{
                maxWidth: 290,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {link}
            </div>
          </Tooltip>
        );
      }
    },

    {
      title: "",
      key: "operation",
      width: 70,
      fixed: "right",
      render: (_, record) => (
        <Link
          to={
            `/admin/quan-ly-trang-chu/` +
            record?.index_page_id
          }
        >
          <Button
            type="text"
            icon={<EditOutlined />}
          />
        </Link>
      )
    }
  ];

  return (
    <>
      <Row
        gutter={10}
        className="mb-[8px]"
        align="middle"
      >
        <Col flex={1}>
          <div
            className="text-[20px] font-medium"
          >
            Quản lý trang chủ
          </div>

          <div
            style={{
              marginTop: 4,
              color: "#64748b",
              fontSize: 13
            }}
          >
            Quản lý banner chính và banner ưu đãi
          </div>
        </Col>

        <Col>
          <Link
            to="/admin/quan-ly-trang-chu/tao-moi"
          >
            <Button type="primary">
              Tạo banner
            </Button>
          </Link>
        </Col>
      </Row>

      <div
        className="w-full h-full mt-5 pb-20 relative"
      >
        <Table
          rowKey="index_page_id"
          className="custom-table"
          dataSource={index}
          columns={columns}
          pagination={false}
          scroll={{
            x: "max-content"
          }}
        />
      </div>
    </>
  );
}
